/* eslint-disable import/no-cycle */
import { Module } from 'vuex';

import { RootStateI } from '../state';
import { state, AuthStateI } from './state';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const module: Module<AuthStateI, RootStateI> = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};

export default module;
